export default "__VITE_ASSET__DyUapFWO__"